import React, { createContext, useState } from 'react';

// Contextの作成
export const FilenameContext = createContext();

// Context Providerの作成
export const FilenameProvider = ({ children }) => {
    // 初期値の定義
    const initialFilenameState = ''; 
    const initialTokenState = ''; 

    // 状態管理
    const [fileList, setFileList] = useState([]); // [{ filename: "a.mp3", token: "xxx", channelId: "ch1" },
    const [filename, setFilename] = useState(initialFilenameState);
    const [tempfilename, settempFilename] = useState(initialFilenameState);
    const [token, setToken] = useState(initialTokenState);

    // リセット関数
    const resetFilename = () => {
        setFilename(initialFilenameState);
        setToken(initialTokenState);
        settempFilename(initialFilenameState);
    };
    const resetFileList = () => {
        setFileList([]);
    };
    return (
        <FilenameContext.Provider 
            value={{
                fileList,
                setFileList,
                filename,
                setFilename,
                tempfilename,
                settempFilename,
                token,
                setToken,
                resetFilename,
                resetFileList,
            }}
        >
            {children}
        </FilenameContext.Provider>
    );
};
